import { Dialog } from "@mui/material";
import { X } from "feather-icons-react/build/IconComponents";
import { t } from "i18next";
import { useContext } from "react";
import { ChangePathContext } from "../App";
import { parentNavigate } from "./ParentNavigate";
import { Transition } from "./Transition";

const SaveChangesPopup = () => {
  const { saveChanges, setSaveChanges } = useContext(ChangePathContext);
  return (
    <Dialog
      open={saveChanges?.showChangesPopup}
      TransitionComponent={Transition}
      keepMounted
      onClose={() =>
        setSaveChanges({
          ...saveChanges,
          showChangesPopup: false,
          isUnsaveChanges: true,
        })
      }
      aria-describedby="alert-dialog-slide-description"
    >
      <div className="w-full secondary-bg-color sm:w-[500px] p-6 rounded-[6px]">
        <div className="flex text-primary items-center justify-between">
          <p className="text-lg font-medium">{t("lang_unsaved_changes")}</p>
          <button
            onClick={(e) => {
              e.preventDefault();
              setSaveChanges({
                ...saveChanges,
                showChangesPopup: false,
                isUnsaveChanges: true,
              });
            }}
            className="close-btn"
          >
            <X className="w-4 h-4" />
          </button>
        </div>
        <hr className="my-4 main-border-color"></hr>
        <p className="text-base table-text">{t("lang_unsaved_changes_description")}</p>
        <button
          className="bulk-btn px-[20px] py-[8px] mt-4 me-2 text-[13px]"
          onClick={(e) => {
            e.preventDefault();
            parentNavigate(saveChanges?.backLink);
            setSaveChanges({
              ...saveChanges,
              isUnsaveChanges: false,
              showChangesPopup: false,
            });
          }}
        >
          {t("lang_leave_page")}
        </button>
        <button
          className="btn mt-4 text-white text-[13px]"
          onClick={(e) => {
            e.preventDefault();
            setSaveChanges({
              ...saveChanges,
              isUnsaveChanges: true,
              showChangesPopup: false,
            });
          }}
        >
          {t("lang_stay_on_page")}
        </button>
      </div>
    </Dialog>
  );
};

export default SaveChangesPopup;
